import React, { useEffect } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import './App.css';

function App() {
  useEffect(() => {
    const player = videojs('my-video');
    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, []);

  return (
    <div className="App">
      <video
        id="my-video"
        className="video-js vjs-default-skin"
        controls
        preload="auto"
        width="640"
        height="264"
      >
        <source src="https://d1hj39d0u1it36.cloudfront.net/hls/output_720p.m3u8" type="application/x-mpegURL" />
      </video>
    </div>
  );
}

export default App;
